<template>
  <section class="f-59">
    <div ref="AiSwiper" class="font-group f-select-center">
      <div class="title f-center-title">AI 多维感知，车主需求主动响应</div>
      <f-swiper v-model:index="index" :total="controlList.length" v-ia>
        <div v-for="(item, index) in controlList" class="swiper-item">
          <div class="swiper-item-card">
            <img
              v-if="item.type === 'img'"
              class="img"
              :src="item.url"
              alt=""
            />
            <m-video
              v-else
              class="video"
              :ref="`video${index}`"
              :src="item.url"
              muted
              playsinline
              webkit-playsinline
              disablepictureinpicture
            />
            <Replay
              v-if="item.type === 'video'"
              class="replay"
              @click="replayVideo($refs[`video${index}`][0])"
            />
          </div>
          <div class="swiper-title">{{ item.title }}</div>
          <div class="swiper-subtitle">{{ item.subTitle }}</div>
        </div>
      </f-swiper>
    </div>
  </section>
</template>

<script>
import Replay from '@/components/replay.vue'
import { replayVideo } from '@/utils'
export default {
  name: 'Assistant',
  components: {
    Replay,
  },
  data() {
    return {
      preload_: true,
      index: 0,
      timer: null,
      isActive: false,
      controlList: [
        {
          title: '开门危险，先知预警',
          subTitle: '副驾开门遇后方来车，屏幕即刻弹出警示小窗',
          type: 'img',
          url: require('@/v2/auto/assets/image/59/0.jpg'),
        },
        {
          title: '自动除霜，视野无余',
          subTitle: '挡风玻璃有霜、雾时，自动为你清除',
          type: 'video',
          url: require('@/v2/auto/assets/video/59/1.mp4'),
        },
        {
          title: '感应尾门，解放双手',
          subTitle: '视觉识别用户动作，后备箱自动优雅开启',
          type: 'video',
          url: require('@/v2/auto/assets/video/59/2.mp4'),
        },
        {
          title: '穿透雨雾，智慧灯控',
          subTitle: '雨雾天气自动开启雾灯，极大提升穿透力',
          type: 'video',
          url: require('@/v2/auto/assets/video/59/3.mp4'),
        },
        {
          title: '夜视增强，清晰如昼',
          subTitle: '智能增强夜间成像，精准掌控暗夜倒车视野',
          type: 'video',
          url: require('@/v2/auto/assets/video/59/4.mp4'),
        },
        {
          title: '智控车窗，提前预判',
          subTitle: '智能识别车内外环境，为你自动执行',
          type: 'video',
          url: require('@/v2/auto/assets/video/59/5.mp4'),
        },
      ],
    }
  },
  watch: {
    index() {
      this.initAutoPlay()
    },
  },
  mounted() {
    this.$gsap.timeline({
      scrollTrigger: {
        trigger: this.$refs.AiSwiper,
        onUpdate: (self) => {
          if (self.isActive) {
            // 只有显示时才执行
            if (this.isActive) return
            this.isActive = true
            this.initAutoPlay()
          } else {
            // 不显示时恢复到初始状态
            this.isActive = false
            this.index = 0
            this.timer && clearTimeout(this.timer)
            this.controlList.forEach((item, i) => {
              this.pauseHandler(item, i)
            })
          }
        },
      },
    })
  },
  methods: {
    replayVideo,
    initAutoPlay() {
      if (this.isActive) {
        this.controlList.forEach((item, i) => {
          if (i === this.index) {
            this.playHandler(item, i)
          } else {
            this.pauseHandler(item, i)
          }
        })
      }
    },
    playHandler(item, index) {
      if (item.type === 'img') {
        this.timer =
          this.index < this.controlList.length - 1 &&
          setTimeout(() => {
            this.videoPlayHandler()
          }, 6000)
      } else {
        const video = this.$refs[`video${index}`][0]
        video.currentTime = 0
        video.play()
        video.addEventListener('ended', this.videoPlayHandler)
      }
    },
    pauseHandler(item, index) {
      if (item.type === 'video') {
        const video = this.$refs[`video${index}`][0]
        video.currentTime = 0
        video.pause()
        video.removeEventListener('ended', this.videoPlayHandler)
      }
    },
    videoPlayHandler() {
      this.timer && clearTimeout(this.timer)
      this.index = (this.index + 1) % this.controlList.length
      this.initAutoPlay()
    },
  },
}
</script>

<style lang="less" scoped>
.f-59 {
  background-color: black;
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 59;
  margin-top: -5px;

  .font-group {
    height: auto;
    position: relative;

    .swiper-item {
      width: 100%;
      margin-right: 30px;
      color: #fff;

      .swiper-item-card {
        width: 100%;
        aspect-ratio: 24/11;
        overflow: hidden;
        border-radius: 30px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
        video {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
        .replay {
          position: absolute;
          bottom: 20px;
          right: 30px;
          z-index: 10;
        }
      }
      .swiper-title {
        font-size: 24px;
        font-weight: bold;
        color: #fff;
        margin-top: 30px;
      }
      .swiper-subtitle {
        font-size: 16px;
        color: #ffffffcc;
        margin-top: 8px;
      }
    }
    // Title styles
    .title {
      width: 100%;
      margin-top: 150px;
      margin-bottom: 63px;
      line-height: 1.2;
      font-weight: bold;
      text-align: center;
      background: radial-gradient(
        131.96% 70.14% at 50% 18.06%,
        #eadaff 0%,
        #ffffff 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
</style>
